import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import RegFont from "../../common/RegFont";
import { subscriptionText } from "../../SubscriptionPageV2/constants";
import styles from "./styles.module.scss";
const OrderInfo = () => {
    const location = useLocation();
    const ordersInfo = useSelector((state) => state.ordersInfo);
    const shippedStatus = ordersInfo.orderStatusData.status === "SHIPPED";
    const hasSubscription = useSelector((state) => state.user.has_subscription);
    const getBannerCopy = () => {
        if (hasSubscription) {
            return subscriptionText.order_info(ordersInfo.orderStatusData.order_date, `${Number(ordersInfo.nextOrderDates.nextShipmentMonth) + 1}/${ordersInfo.nextOrderDates.nextShipmentDay}`, shippedStatus);
        }
        if (location.pathname.indexOf("subscription") >= 0) {
            return "Reactive your subscription to make edits and/or receive your next order.";
        }
        if (location.pathname.indexOf("home") >= 0) {
            return "ACCOUNT CANCELED";
        }
        return "";
    };
    return getBannerCopy() && (shippedStatus || ordersInfo.orderStatusData.status === "In Progress") ? (_jsx("div", { className: styles.orders_info_wrapper, children: _jsxs(RegFont, { fontWeight: 400, children: [getBannerCopy(), shippedStatus && (_jsx("a", { target: "_blank", rel: "noreferrer", className: styles.underlined_link, href: ordersInfo.orderStatusData.tracking_url || "", children: subscriptionText.view_tracking_details }))] }) })) : null;
};
export default OrderInfo;
